import { styled } from "@mui/system";

export const Grid = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(2,1fr)",
  gap: "1rem",
}));

export const FormGroup = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 6,
  marginBottom: 16,
}));

export const Label = styled("label")(() => ({
  fontSize: 14,
  fontWeight: 500,
  //color: "#374151",
}));

export const Input = styled("input")(() => ({
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #d1d5db",
  fontSize: 14,
  outline: "none",
}));

export const TextArea = styled("textarea")(() => ({
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #d1d5db",
  fontSize: 14,
  minHeight: 120,
  resize: "vertical",
  outline: "none",
}));

export const ModalFooter = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: 12,
  marginTop: 24,
}));

export const Button = styled("button")(() => ({
  padding: "10px 16px",
  borderRadius: 8,
  fontSize: 14,
  cursor: "pointer",
  border: "none",
  backgroundColor: "#2563eb",
  color: "#ffffff",
  "&.cancel": {
    backgroundColor: "#e5e7eb",
    color: "#111827",
  },
}));
